export default {"src":"__ASTRO_ASSET_IMAGE__BAMZwN0i__","width":88,"height":88,"format":"svg"}